export default "__VITE_ASSET__$HlDuFeE__"